import React from 'react';

const SvgDiscard = ({ svgRef, title, ...props }) => (
  <svg width="1em" height="1em" viewBox="0 0 96 96" ref={svgRef} {...props} fill="currentColor">
    <title>{title}</title>
    <path d="M1.2 1.2C.5 1.9 0 4 0 5.9 0 9.2 1.5 11 19.2 28.7L38.5 48 19.2 67.3C1.5 85 0 86.8 0 90.1 0 94.5 1.5 96 5.9 96c3.3 0 5.1-1.5 22.8-19.2L48 57.5l19.3 19.3C85 94.5 86.8 96 90.1 96c4.4 0 5.9-1.5 5.9-5.9 0-3.3-1.5-5.1-19.2-22.8L57.5 48l19.3-19.3C94.5 11 96 9.2 96 5.9 96 1.5 94.5 0 90.1 0 86.8 0 85 1.5 67.3 19.2L48 38.5 28.7 19.2C11 1.5 9.2 0 5.9 0 4 0 1.9.5 1.2 1.2z" />
  </svg>
);

const ForwardRef = React.forwardRef((props, ref) => <SvgDiscard svgRef={ref} {...props} />);
export default ForwardRef;



// WEBPACK FOOTER //
// ./src/common/icons/Discard.js